  export enum ResourceType { // TODO: clarify in defining this
    SONG = 'song',
    SONG_CONTRACT = 'song_contract',
    SONG_CLIENTS = 'song_clients'
  }
  
  export enum InputFieldLookupType {
    SEARCH = 'search',
    DROPDOWN = 'dropdown'
  }
  
  export interface LookupQuery {
    lookup_type: InputFieldLookupType;
    resource_type: string; // TODO: need to replace string type with ResourceType interface once we clarify full breadth of ResourceType
    value: string | number;
    value_type: string
  }
    
  export interface LookupQueryResponse {
    input: LookupQuery;
    resources: unknown[]; // TODO: need update to reconcile these types
  }

  export interface DataLookupOption {
    '0': string;
    '1': string | number;
  }

  export interface DataLookupResponse {
    Message: string;
    Data: DataLookupOption[];
  }

  export interface S3LinkResponse {
    downloadUrl: string
  }